import React from 'react'

const CheckboxOutlinedIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M20.125 5C21.1406 5 22 5.85938 22 6.875C22 7.5 21.6875 8.04688 21.2188 8.39844L12.7422 14.7656C12.2734 15.1172 11.6875 15.1172 11.2188 14.7656L2.74219 8.39844C2.27344 8.04688 2 7.5 2 6.875C2 5.85938 2.82031 5 3.875 5H20.125ZM10.4766 15.7812C11.375 16.4453 12.5859 16.4453 13.4844 15.7812L22 9.375V17.5C22 18.9062 20.8672 20 19.5 20H4.5C3.09375 20 2 18.9062 2 17.5V9.375L10.4766 15.7812Z"
      fill="#515356"
    />
  </svg>
)

export default CheckboxOutlinedIcon
